import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';

const api = axios.create({
  baseURL: `${STRAPI_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchHeaderData = async () => {
  try {
    const response = await api.get('/header?populate=*');
    return response.data?.data;
  } catch (error) {
    return null;
  }
};

export const fetchFooterData = async () => {
  try {
    const response = await api.get('/footer?populate=*');
    return response.data?.data;
  } catch (error) {
    return null;
  }
};

export const fetchFloatingButtonData = async () => {
  try {
    const response = await api.get('/floating-button?populate=*');
    return response.data?.data;
  } catch (error) {
    return null;
  }
};

export const fetchPages = async () => {
  try {
    const response = await api.get('/pages?populate=*');
    return response.data?.data;
  } catch (error) {
    return [];
  }
};

export const fetchHomeData = async () => {
  return fetchPageData('home');
};


const pageCache = {};
const pendingRequests = {};

export const fetchPageData = async (slug) => {
  try {
    let populateParams = 'populate=*';
    if (slug === 'home' || slug === 'about-us') {
       populateParams = 'populate[0]=blocks&populate[1]=blocks.founder&populate[2]=blocks.founder.image&populate[3]=blocks.members&populate[4]=blocks.members.image&populate[5]=blocks.departments&populate[6]=blocks.departments.members&populate[7]=blocks.departments.members.image&populate[8]=blocks.image&populate[9]=blocks.missionImage&populate[10]=blocks.visionImage&populate[11]=blocks.backgroundImage&populate[12]=seo&populate[13]=blocks.features&populate[14]=blocks.stats&populate[15]=blocks.missionPoints&populate[16]=blocks.visionPillars&populate[17]=blocks.backgrounds&populate[18]=blocks.items&populate[19]=blocks.items.image&populate[20]=blocks.images';
    } else if (slug === 'careers') {
       populateParams = 'populate[0]=blocks&populate[1]=blocks.jobs&populate[2]=blocks.cards&populate[3]=seo&populate[4]=blocks.backgroundImage';
    } else if (slug === 'contact') {
       populateParams = 'populate[0]=blocks&populate[1]=blocks.cards&populate[2]=blocks.questions&populate[3]=seo&populate[4]=blocks.backgroundImage';
    } else {
       populateParams = 'populate[0]=blocks&populate[1]=blocks.image&populate[2]=seo&populate[3]=blocks.backgroundImage&populate[4]=blocks.items';
    }

    const url = `${STRAPI_URL}/api/pages?filters[slug][$eq]=${slug}&${populateParams}`;
    
    // Deduping requests
    if (pendingRequests[url]) {
      return pendingRequests[url];
    }

    const fetchPromise = (async () => {
      try {
        const response = await fetch(url, { cache: 'no-store' });
        const json = await response.json();
        if (json.data && json.data.length > 0) {
          const data = json.data[0];
          pageCache[url] = data; // Cache it
          
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('pageDataUpdated', { detail: { slug, data } }));
          }
          return data;
        }
        return null;
      } catch (err) {
        console.error(`Error fetching ${slug} data:`, err);
        return pageCache[url] || null;
      } finally {
        delete pendingRequests[url];
      }
    })();

    pendingRequests[url] = fetchPromise;
    return pageCache[url] || fetchPromise;

  } catch (error) {
    console.error(`Error fetching ${slug} data:`, error);
    return null;
  }
};


export const getImageUrl = (image) => {
  if (!image) return null;
  if (typeof image === 'string') return image;
  const url = image?.url || image?.data?.attributes?.url;
  if (!url) return null;
  return url.startsWith('http') ? url : `${STRAPI_URL}${url}`;
};

export default api;

export const fetchProjects = async () => {
  try {
    const url = `${STRAPI_URL}/api/projects?populate=*&pagination[limit]=100`;
    const response = await fetch(url, { cache: 'no-store' });
    const json = await response.json();
    return json.data || [];
  } catch (error) {
    console.error("Error fetching projects:", error);
    return [];
  }
};

export const fetchBlogs = async () => {
  try {
    const url = `${STRAPI_URL}/api/blogs?populate=*&pagination[limit]=100`;
    const response = await fetch(url, { cache: 'no-store' });
    const json = await response.json();
    return json.data || [];
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return [];
  }
};

export const fetchLocations = async () => {
  try {
    const url = `${STRAPI_URL}/api/locations?populate=*&pagination[limit]=100`;
    const response = await fetch(url, { cache: 'no-store' });
    const json = await response.json();
    return json.data || [];
  } catch (error) {
    console.error("Error fetching locations:", error);
    return [];
  }
};
